import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HorizontalTabs, HorizontalTabsButton, HorizontalTabsList, HorizontalTabsPanel, HorizontalTabsPanelList } from "@cinch-labs/design-system";
import { Filters } from "../filters/filters";
import styles from "./hero-form.module.css";
import { useState } from "react";
export const HeroForm = ({ totalStock , makes , starRating , starRatingLabel , numberOfReviews , section  })=>{
    const [isFindACarTab, setIsFindACarTab] = useState(true);
    return /*#__PURE__*/ _jsxs(HorizontalTabs, {
        withBorder: true,
        children: [
            /*#__PURE__*/ _jsxs(HorizontalTabsList, {
                ariaLabel: "Find a car",
                children: [
                    /*#__PURE__*/ _jsx(HorizontalTabsButton, {
                        id: "button-id-1",
                        panelId: "panel-id-1",
                        onActive: ()=>setIsFindACarTab(true),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.tabTitle,
                            children: "Find a car"
                        })
                    }),
                    /*#__PURE__*/ _jsx(HorizontalTabsButton, {
                        id: "button-id-2",
                        panelId: "panel-id-2",
                        onActive: ()=>setIsFindACarTab(false),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.tabTitle,
                            children: "Part-exchange"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(HorizontalTabsPanelList, {
                children: [
                    /*#__PURE__*/ _jsxs(HorizontalTabsPanel, {
                        buttonId: "button-id-1",
                        id: "panel-id-1",
                        className: styles.filtersContent,
                        children: [
                            isFindACarTab && /*#__PURE__*/ _jsx(Filters, {
                                section: section,
                                makes: makes,
                                totalStock: totalStock,
                                starRating: starRating,
                                starRatingLabel: starRatingLabel,
                                numberOfReviews: numberOfReviews
                            }),
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(HorizontalTabsPanel, {
                        buttonId: "button-id-2",
                        id: "panel-id-2",
                        className: styles.filtersContent,
                        children: [
                            !isFindACarTab && /*#__PURE__*/ _jsx("h2", {
                                className: styles.test,
                                children: "Hello Part Exchange component"
                            }),
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
};
